import React from 'react';
import Footer from '../Components/Footers/Footer';
import Header from '../Components/Headers/Header';
import '../assests/css/OurFleet.css';
import GroupIcon from '@mui/icons-material/Group';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link } from 'react-router-dom';
import image_car1 from '../assests/images/img-ourfleet-map.png';
import image_car2 from '../assests/images/img-ourfleet-map2.png';
import vito from '../assests/images/car.png';
import img_car_imp2 from '../assests/images/mercedes_white.png';
import skoda from '../assests/images/skoda.png';
import galaxy from '../assests/images/galaxy.png';
import ford_bg from '../assests/images/ford-galaxy_bg.jpg';
import vito_bg from '../assests/images/img-ourfleet-map.png';
import meredes_bg from '../assests/images/bg-merced.png';
import sokda_bg from '../assests/images/skoda_bg.webp';

// ../images/car.png

const OurFleet = () => {

    let arr = [
        {
            busType: "Skoda Superb & Toyota Avensis Estate",
            description: "Skoda Superb comes with a robust heart or what we can say ‘Engine,’ Its elegant looks and comfort are what every person desires. The reason for including these vehicles in our fleet was the luxury, safety, and satisfaction of our clients.",
            no_passengers: "• An online payment system is available.",
            no_largebags: "• Flight tracking is offered.",
            no_smallbags: "• You can load up to 2 Large and 3 small suitcases.",
            bg_img_car: `${sokda_bg}`,
            img_car: `${skoda}`,
        }, {
            busType: "Executive ,Mercades, Tesla & Bmw …",
            description: "What else dose one need when they are travelling in an All-Wheel-Drive Sedan? Mercedes C Class is one of the top-rated sedans that will make your journey smooth and swift. Its graceful style and premium interior have no match. Our clients are beloved for us, and we cannot compromise on our taxi service, so we introduced this model to our fleet collection.",
            no_passengers: "• Online payment method available",
            no_largebags: "• Flight Tracking service is available ",
            no_smallbags: "• You can load up to 1 large suitcase and 3 small suitcases",
            bg_img_car: `${meredes_bg}`,
            img_car: `${img_car_imp2}`,
        }, {
            busType: "MPV ford galaxy",
            description: "Are you looking for a 6 seater? You are at the right spot. Metro 24 x 7 has purchased Ford Galaxy, so our clients do not have to worry if they have extra suitcases or the whole family wants to travel in one vehicle. ",
            no_passengers: "• An online payment method is available.",
            no_largebags: "• Flight Tracking service is offered",
            no_smallbags: "• You can load up to 4 large suitcases and 3 small suitcases.",
            bg_img_car: `${ford_bg}`,
            img_car: `${galaxy}`,
        }, {
            busType: "Mini Bus Mercedes vito",
            description: "Are you travelling in a large group? Contact us to book Mercedes Vito. It is a great medium-sized van that is perfect for 8 people with a lot of luggage. Its comfort level is out of the ordinary, and we already know that you will acknowledge its smoothness and comfort. ",
            no_passengers: "• An online payment method is available.",
            no_largebags: "• Flight Tracking service is offered.",
            no_smallbags: "• You can load up to 8 large suitcases and 4 small suitcases.",
            bg_img_car: `${vito_bg}`,
            img_car: `${vito}`,
        }
    ];

    return (
        <div className='ourfleet'>
            <section className='bg-privacy-policy-top mb-3'>
                <Header />
                <div className='container px-5'>
                    <div className='row px-3'>
                        <div className='col-lg-12 my-4 text-center'>
                            <p className='text-white f-72 my-5 f-pop-med'>Our Fleet</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='ourfleet-content'>
                <div className='container'>
                    <div className='row my-5'>
                        <div className='col-lg-12 mt-5 mb-3'>
                            <p className='clr-df f-20 f-pop-med'>Our Vehicle</p>
                            <p className='clr-1c f-25 f-pop-med mt-1 mb-4'>Hybrid Vehicles</p>
                        </div>
                        {
                            arr.map((item, index) => {
                                let state_content = {
                                    image: item.img_car,
                                    bg_img: item.bg_img_car,
                                    vehicile_type: item.busType,
                                    small_bags: item.no_smallbags,
                                    large_bags: item.no_largebags,
                                    passgener_no: item.no_passengers,
                                    desc: item.description
                                }

                                return (
                                    <Link state={state_content} key={index} to="/singlefleet" className='link_ourfleet'>
                                        <div className='col-lg-12 mb-10rem'>
                                            <div
                                                //  background-image: linear-gradient(to bottom, rgba(140, 139, 169, 0.5), rgba(140, 139, 169, 0.5)),
                                                //  url('../images/img-ourfleet-map.png');
                                                style={{ backgroundImage: `linear-gradient(to bottom, rgba(140, 139, 169, 0.5), rgba(140, 139, 169, 0.5)),url(${item.bg_img_car})` }}
                                                className='img-ourfleet-map'>
                                                <div className='row'>
                                                    <div className='col-lg-4 '>
                                                        <div className='bg-red-carinfo pt-5 px-4'>
                                                            <p className='mt-5 f-pop-med f-18 mb-2'>{item.busType}</p>
                                                            <p className='f-pop-med f-13 lh-02 mb-4'>
                                                                {item.description}
                                                            </p>
                                                            <div className='row'>
                                                                <div className='col-lg-12 mb-2 text-res-ourfleet-details'>
                                                                    <span className='f-pop-med f-12'>  {item.no_passengers}</span>
                                                                </div>
                                                                <div className='col-lg-12 mb-2 text-res-ourfleet-details'>
                                                                    <span className='f-pop-med f-12'>
                                                                        {/* <DeleteIcon className='me-2' /> */}
                                                                        {item.no_largebags}</span>
                                                                </div>
                                                                <div className='col-lg-12 mb-2 text-res-ourfleet-details'>
                                                                    <span className='f-pop-med f-12'>  {item.no_smallbags} </span>
                                                                </div>
                                                                <div className='col-lg-12 text-end'>
                                                                    <p className='f-pop-med f-135 lh-1 opacity-0-2'>0{index + 1}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-8'>
                                                        <div className='pos-rel car-cen-fleet'>
                                                            <div style={{ backgroundImage: `url(${item.img_car})` }} className='bg-car-ourfleet'>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                )
                            })
                        }
                    </div>
                </div>
            </section >
            <Footer />
        </div >
    )
}

export default OurFleet;